import {
    CODE_AMENDS_KEY,
    INTRO_CONTENT_AMENDS_KEY,
    INTRO_NOTE_AMENDS_KEY,
    LEADING_SUMMARY_AMENDS_KEY,
    LEGISLATION_AMENDS_KEY_PREFIX,
    MOVEMENTS_AMENDS_KEY,
    TASK_AMENDS_KEY_PREFIX,
    TITLE_AMENDS_KEY,
    UNIT_OF_MEASURE_AMENDS_KEY,
} from "./constants/amends-keys"
import { normalisePlainText } from "./normalise-plain-text.mjs"

export function getTaskAmendsKey(task) {
    const taskId = getTaskAmendsId(task)
    return taskId ? `${TASK_AMENDS_KEY_PREFIX}${taskId}` : null
}

export function getAmendsKeyLabel({ amendsKey, draft }) {
    switch (amendsKey) {
        case LEADING_SUMMARY_AMENDS_KEY:
            return "Leading summary"
        case TITLE_AMENDS_KEY:
            return "Schedule title"
        case CODE_AMENDS_KEY:
            return "Schedule code"
        case UNIT_OF_MEASURE_AMENDS_KEY:
            return "Schedule unit of measure"
        case INTRO_CONTENT_AMENDS_KEY:
            return "Introduction content"
        case INTRO_NOTE_AMENDS_KEY:
            return "Introduction notes"
        case MOVEMENTS_AMENDS_KEY:
            return "Task order"
        default:
            if (amendsKey?.startsWith(LEGISLATION_AMENDS_KEY_PREFIX)) {
                return getLegislationAmendsLabel(amendsKey)
            }
            return getTaskAmendsLabel({ amendsKey, draft })
    }
}

function getTaskAmendsLabel({ amendsKey, draft }) {
    if (!amendsKey?.startsWith(TASK_AMENDS_KEY_PREFIX)) return amendsKey

    const taskId = amendsKey.slice(TASK_AMENDS_KEY_PREFIX.length)
    const draftTask = (draft?.tasks ?? []).find((task) => getTaskAmendsId(task) === taskId)
    if (!draftTask) return `Task (${taskId})`

    const taskType = draftTask.isHeader ? "Header" : "Task"
    const taskTitle = normalisePlainText(draftTask.title) || taskId
    return `${taskType}: ${taskTitle}`
}

function getTaskAmendsId(task) {
    return task?.headerTaskId ?? task?.taskId ?? null
}

function getLegislationAmendsLabel(amendsKey) {
    const legislationId = amendsKey.slice(LEGISLATION_AMENDS_KEY_PREFIX.length)
    return legislationId ? `Reference (${legislationId})` : "Reference"
}
